<template>
  <transition>
    <div v-show="time" :class="$style.base">
      <BaseButton
        :isLoading="loading"
        @click="submit"
        v-test="'reschedule-confirm'"
      >
        {{ $t('confirmation.confirm') }}
      </BaseButton>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { ref } from 'vue';

import axios from '@/axios';
import BaseButton from '@/components/BaseButton.vue';
import { useBookingStore } from '@/stores/booking';
import widgetSettings from '@/widget-settings';

const { time } = storeToRefs(useBookingStore());
const loading = ref(false);
const emit = defineEmits(['submit']);

const submit = () => {
  const { locationId, date, time } = useBookingStore();
  loading.value = true;

  axios
    .put(`/locations/${locationId}/bookings/${widgetSettings.bookingId}`, {
      date,
      time
    })
    .then(({ data: { booking } }) => {
      const bookingStore = useBookingStore();
      bookingStore.bookingResponse = booking;
      emit('submit');
    })
    .finally(() => {
      loading.value = false;
    });
};
</script>

<style lang="scss" module>
.base {
  display: flex;
  justify-content: center;
  padding: $spacing;
  box-shadow: 0 -7px 13px rgba(0, 0, 0, 0.08);
  transition: transform 0.15s ease-out;
  position: relative;
  z-index: 1;

  &:global(.v-enter-from),
  &:global(.v-leave-to) {
    transform: translateY(100%);
  }
}
</style>
